import { Routes } from '@angular/router';
import { MorphemeBoardAssignmentsPage } from './morpheme-board-assignments-page/morpheme-board-assignments-page';
import { MorphemeBoardFreeformPage } from './morpheme-board-freeform-page/morpheme-board-freeform-page';
import { MorphemeBoardPage } from './morpheme-board-page';

export const mechanicMorphemeBoardRoutes: Routes = [
  {
    path: '',
    component: MorphemeBoardPage,
  },
  {
    path: 'freeform',
    component: MorphemeBoardFreeformPage,
  },
  {
    path: 'assignments',
    component: MorphemeBoardAssignmentsPage,
  },
];
